import { request } from '@/request/request';
import { parameterChange } from '@/utils';

export default {
  // 标签列表
  tagPageList(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/tag/tagPageList?${parameterChange(data)}`,
      method: 'get',
      data,
    });
  },
  // 标签新增
  tagAdd(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/tag/tagAdd`,
      method: 'post',
      data,
    });
  },
  // 标签编辑
  tagUpdate(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/tag/tagUpdate`,
      method: 'post',
      data,
    });
  },
  // 标签删除
  tagDelete(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/tag/tagDelete`,
      method: 'post',
      data,
    });
  },
};
